import { GraphQLError } from "graphql"

import { getCustomer } from "../utils/getCustomer"

export const checkAdmAccessRightsToAdmNumber = async ({ user, admNumber }) => {
  if (!isAdmNumberOfUser({ user, admNumber })) {
    throw new GraphQLError("You are not authorized to perform this operation.", {
      extensions: {
        code: "FORBIDDEN",
      },
    })
  }
}

export const isAdmNumberOfUser = async ({ user, admNumber }) => {
  const userData = await getCustomer({ id: user.id })
  return userData.custom.fields.admNumbers.includes(admNumber)
}
